const location = {
  lat: 0,
  lng: 0,
  zoom:0,

  toArray() {
    return [this.lat, this.lng,this.zoom];
  },

  init(lat = 0, lng = 0,zoom=0) {
    this.lat = lat;
    this.lng = lng;
    this.zoom = zoom;
  }

};

export default {
  init(lat = 0, lng = 0,zoom=0) {
    const l = Object.create(location);
    l.init(lat, lng,zoom);
    return l;
  }
}